import { createContext } from 'react';

import { IResource } from '../ResourceCard';

export interface ResourceDetailInfo {
  data: IResource;
  onboardingStep: number;
  setOnboardingStep: React.Dispatch<React.SetStateAction<number>>;
  hideLastStep: boolean;
  navHeight?: number;
  setNavHeight?: React.Dispatch<React.SetStateAction<number>>;
  setIsEditing?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ResourceDetailContext = createContext<ResourceDetailInfo>({
  data: null,
  onboardingStep: 1,
  setOnboardingStep: () => {},
  hideLastStep: false,
  navHeight: 0,
  setNavHeight: () => {},
  setIsEditing: () => {},
});
